import React, { useState, useRef, useEffect } from 'react'
import cn from 'classnames'
import Button from '../Button'
import './index.scss'

const ButtonPanel = ({
  panelClassname,
  iconComponent: Icon,
  contentComponent: Content,
  closePanel = false,
  id
}) => {
  const [panelOpen, setPanelOpen] = useState(false)
  const buttonRef = useRef()
  const panelRef = useRef()

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'touchstart']

    const handler = ({ key, target }) => {
      if (
        key
          ? key !== 'Escape'
          : buttonRef.current?.contains(target) ||
            panelRef.current?.contains(target)
      ) {
        return
      }
      setPanelOpen(false)
    }

    events.forEach((event) => {
      document.addEventListener(event, handler)
    })

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, handler)
      })
    }
  }, [])

  useEffect(() => {}, [])

  useEffect(() => {
    if (closePanel) {
      setPanelOpen(false)
    }
  }, [closePanel])

  return (
    <div className='ublique-button-panel'>
      <Button
        ref={buttonRef}
        hasIconOnly
        renderIcon={Icon}
        kind='ghost'
        onClick={() => setPanelOpen(!panelOpen)}
        id={id}
      />
      {panelOpen && (
        <div
          ref={panelRef}
          className={cn('ublique-button-panel__content', panelClassname)}
        >
          {Content}
        </div>
      )}
    </div>
  )
}

export default ButtonPanel
